import React from 'react';

import './Loader.css';

export const Loader = (props) => {
  const { type } = props;
  return (
    <div className={`Loader ${type}`}>
        <i className="fa fa-spin fa-spinner" />
    </div>
  )
}

export default Loader;
